import Swiper, { Navigation, Pagination } from 'swiper';

export default class SwiperBigGalleryWidget {
    listSlider;
    classSlider;
    optionsSlider = {
        loop: false,
        allowTouchMove: false,
        autoHeight: true
    }
    pagination = {
        el: ".swiper-pagination",
        type: "fraction",
    }

    constructor(opts = {}) {
        this.listSlider = null;
        this.optionsSlider = opts?.options ? {
            ...this.optionsSlider,
            ...opts?.options
        } : this.optionsSlider;
        this.classSlider = opts.classSlider || '.js-swiper-bigGallery';
        this.pagination = opts.pagination || this.pagination
    }

    _createSlider(element){
        new Swiper(element, {
            modules: [Navigation, Pagination],
            ...this.optionsSlider,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev"
            },
            pagination: this.pagination,
        });
    }

    init(){
        this.listSlider = document.querySelectorAll(this.classSlider);

        if (this.listSlider.length > 0) {
            Array.from(this.listSlider).forEach((element) => {
                if (!element.classList.contains('swiper-initialized')){
                    this._createSlider(element);
                }
            });
            console.log('Slider Big Gallery Init');
        }
    }
}
